export default "__VITE_ASSET__c7b0874f__"